





















import {
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'

import CustomSelectTemplate from '@/components/organisms/h/item/hierarchy/CustomSelectTemplate.vue'
import {
  emitHierarchySelect,
  itemHierarchyType,
  emitHierarchySearch,
  emitCustomSelectSelect,
} from '@/types/entities'
import {
  ExtractVUiPAreasDocument,
  UiPAreaEdge,
  Where,
  OrderByDirection,
  OrderBy,
  OrderByNullsOption
} from '@/types/generated/graphql'
import { MAX_COUNT } from '@/utils/constant'
import Toast, { genNotifyMessage } from '@/utils/toast'

export default defineComponent({
  components: { CustomSelectTemplate },
  props: {
    where: {
      type: Array as PropType<Where[]>,
      default: () => [],
    },
    orderBy: {
      type: Array as PropType<string[]>,
      default: () => [
        {
          field: 'areaType',
          direction: OrderByDirection.Desc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'areaCd',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
      ],
    },
    itemHierarchyType: {
      type: String as PropType<itemHierarchyType>,
      default: '',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    areaType: {
      type: Array as PropType<string[]>,
      default: () => ['0', '1'],
    },
  },
  apollo: {
    vUiPAreas: {
      query: ExtractVUiPAreasDocument,
      variables() {
        return this.searchCond
      },
      skip: true,
      fetchPolicy: 'cache-and-network',
      error(e: ApolloError) {
        Toast.error(this, {
          message: genNotifyMessage('e.list', 'tanaPattern', e),
        })
      },
    },
  },
  created() {
    this.$apollo.queries.vUiPAreas.skip = false
    this.isSkipQuery = false
  },
  data() {
    return {
      vUiPAreas: { edges: [] },
      // 表示を制御するためのフラグ（データを触ると想定しない挙動となるため用意した）
      isSkipQuery: true,
      totalCount: 0,
      first: MAX_COUNT,
    }
  },
  setup(props, context) {
    let itemLabel = ''
    let textLabel = ''
    console.log(props.areaType)
    if (props.areaType.includes('2')) {
      itemLabel = '棚パターン'
      textLabel = '棚パターン名'
    } else {
      itemLabel = '店舗エリア'
      textLabel = '店舗エリア名'
    }

    return { itemLabel, textLabel }
  },
  computed: {
    isLoading() {
      return this.$apollo.queries.vUiPAreas.loading
    },
    storeShelvesList() {
      return this.vUiPAreas.edges.map((ele: UiPAreaEdge) => {
        return {
          value: ele.node?.areaCd,
          text: ele.node?.areaName,
          key: ele.node?.areaCd,
        }
      })
    },
    searchCond(props: any) {
      return {
        where: props.where,
        orderBy: props.orderBy,
        first: this.first,
      }
    },
  },
  watch: {
    where(newVal) {
      this.resetFirst()
    },
    vUiPAreas(data) {
      this.totalCount = this.vUiPAreas.totalCount
    },
  },
  methods: {
    changeSelected(emitParams: emitCustomSelectSelect) {
      const setectedMetaInfo = this.vUiPAreas.edges.filter(
        (ele: UiPAreaEdge) => {
          const key = ele.node?.areaCd
          if (key) {
            for (const selKey of emitParams.keyList) {
              if (selKey.indexOf(key) !== -1) {
                return true
              }
            }
          }
        }
      )
      const params: emitHierarchySelect = {
        itemHierarchyType: 'StoreShelve',
        selected: emitParams.selectList,
        selectedCount: emitParams.selectedCount,
        setectedMetaInfo: setectedMetaInfo,
      }
      this.$emit('change-selected', params)
    },
    onSearchWord(params: emitHierarchySearch) {
      console.log('search-word')
      this.$emit('search-word', params)
    },
    onSearch(params: emitHierarchySearch) {
      this.$emit('search', params)
    },
    countOverOk(params: any) {
      this.first = params
    },
    resetFirst() {
      this.first = MAX_COUNT
    },
  },
})
